import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=4a4e3c31&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4e3c31')) {
      api.createRecord('4a4e3c31', component.options)
    } else {
      api.reload('4a4e3c31', component.options)
    }
    module.hot.accept("./arrow.vue?vue&type=template&id=4a4e3c31&", function () {
      api.rerender('4a4e3c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/svg-media/arrow.vue"
export default component.exports